import React, { useEffect, useState } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AxiosInstance from "../../../Services/AxiosInstance";
import { API_ENDPOINTS } from "../../../Services/Services";
// import UserForm from "./UserForm";
import Multiselect from 'multiselect-react-dropdown';

 import "./UserDetails.css";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import DisableUser from "./DisableUser/DisableUser";
import Loader from "../../../DesignLayout/Loader/Loader";
const UserDetails = () => {
  const [users, setUsers] = useState([]);
  const [permissionss, setpermissions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userPermissionn, setUserPermissionn] = useState([]);
  const [disableMode, setDisableMode] = useState(false);
  const navigate=useNavigate();
  const [Loading,setLoading]=useState(false);
const location = useLocation();
 const { userId } = location.state || {};

 const [showDisableComponent, setShowDisableComponent] = useState(false);
const [selectedAssignedTo, setSelectedAssignedTo] = useState([]);
 const[tasks,settask]=useState([]);
 const [role,setRole]=useState([]);
 const[bugs,setbug]=useState([]);
 const[projects,setproject]=useState([]);
const [updateuser, setUpdate]=useState({
  userId:userId,
userName:'',
email:'',
contact_No:'',
role:0,
Permission: '',
});



const[Reassign,setReassign]=useState({
  projectTaskId:0,
  assignedToPerson:''

})
  // Fetch users from API
  useEffect(() => {
    const fetchUsers = async () => {
      try {    
        const [response] = await Promise.all([
            AxiosInstance.get(`${API_ENDPOINTS.GET_USERDETAILS_PAGE}?userId=${userId}`),
        ]);
        setUsers(response.data.userDetails||[] );
        setUserPermissionn(response.data.userDetails[0] || '');
       setRole(response.data.role ||[])
       setproject(response.data.projects ||[])
       setbug(response.data.bugs ||[])
       settask(response.data.tasks ||[])
        console.log(response.data.userDetails[0].permission);
        
      } catch (error) {
        toast.error("Failed to load user data.");
      }
    };
    fetchUsers();
  }, [userId]);

  useEffect(() => {
      console.log(userPermissionn.permission);
      
  }, [userPermissionn]);

  // Function to handle checkbox changes
const handleCheckboxChange = (value, isChecked) => {
  let permissionsArray = userPermissionn.permission ? userPermissionn.permission.split(',') : [];

  if (isChecked) {
    // Add value if not already in array
    if (!permissionsArray.includes(value.toString())) {
      permissionsArray.push(value.toString());
    }
  } else {
    // Remove value if unchecked
    permissionsArray = permissionsArray.filter((item) => item !== value.toString());
  }

  // Update state with new comma-separated string
  setUserPermissionn({
    ...userPermissionn,
    permission: permissionsArray.join(','),
  });
};

 
  // Handle selection
 const onSelect = (selectedList) => {
  // Join selected user ids into a comma-separated string
  setSelectedAssignedTo(selectedList);
  const selectedUserIds = selectedList.map((item) => item.userId).join(',');
  setReassign((prevTask) => ({
    ...prevTask,
    assignedToPerson: selectedUserIds, // Store as a string
  }));
};

// Handle removal
const onRemove = (selectedList) => {
  setSelectedAssignedTo(selectedList);
  // Join remaining selected user ids into a comma-separated string
  const selectedUserIds = selectedList.map((item) => item.userId).join(',');
  setReassign((prevTask) => ({
    ...prevTask,
    assignedToPerson: selectedUserIds, // Store as a string
  }));
};

  const [showBugSession, setShowBugSession] = useState(false); // Track which section to show

 
  

  // Open modal for add/edit user
  const handleShowModal = (user = null) => {
    setSelectedUser(user);
    
    setShowModal(true);
  };
  // Close modal
  const handleCloseModal = () => {
    setSelectedUser(null);
    setShowModal(false);
  };

  // Delete user
  const handleDeleteUser = async (userId) => {
    try {
      await AxiosInstance.delete(`${API_ENDPOINTS.DELETE_USER}/${userId}`);
      setUsers(users.filter((user) => user.userId !== userId));
      toast.success("User deleted successfully.");
    } catch (error) {
      toast.error("Failed to delete user.");
    }
  };

  const handleprojectpage = (projectId) => {
    navigate("/projectdetails", { state: { projectId } });
  };
  const handletaskpage = (taskId) => {
    navigate("/taskdetails", { state: { taskId } });
  };
  const handlebugpage = (bugId) => {
    navigate("/bugdetails", { state: { bugId } });
  };
//   const toggleProjects = () => {
// fetchProject();
//     setShowProjects(!showProjects);
//   };

//   const toggleTasks = () => {
//     fetchtask();
//         setshowTasks(!showProjects);
//       };

//       const toggleBugs= () => {
//         fetchbug();
//             setshowBugs(!showProjects);
//           };

 // Get status color
 const getStatusColor = (status) => {
  switch (status) {
    case "Open":
    case "1":
      return "#ffc107";
    case "InProgress":
    case "2":
      return "#198754";
    case "OnHold":
    case "3":
      return "#17a2b8";
    case "Completed":
    case "4":
      return "#28a745";
    case "ToBeTested":
    case "6":
      return "#0d6efd";
    default:
      return "#dc3545";
  }
};

const disableuser = async (e) => {
  e.preventDefault();
  
  if (tasks.length === 0 && bugs.length === 0 && projects.length === 0) {
    alert("User Disabled");
    
    console.log("User Disabled");
  } else {

    setDisableMode(false); // Show the DisableUser component
  }
};


const userupdate=async(e)=>{
  e.preventDefault();
  const defaultuser =users[0];
const roledata = role.filter((x)=>x.name===defaultuser.role).map((r)=>r.id)
console.log(defaultuser.contact_No);

  const updateduser = { ...updateuser,
    userName:updateuser.userName || defaultuser.userName,
    email:updateuser.email || defaultuser.email,
    contact_No:updateuser.contact_No || defaultuser.contact_No,
    role:parseInt(updateuser.role || roledata),
    permission: userPermissionn.permission
  };
  setLoading(true);
  try{

  const response= await AxiosInstance.put(API_ENDPOINTS.UPDATE_USER,updateduser);
  if(response.status===200){
    sessionStorage.setItem("UserMessage","User updated successfully");
    navigate("/Reports")
  }
  else{
    toast.error("Failed to update user");
  }
  }
  catch(error){
    toast.error("Failed to update user");
  }
  finally{
    setLoading(false);
  }
}
window.onload = () => {
    const message = sessionStorage.getItem("UserMessage");
    if (message) {
        toast.success(message);
        sessionStorage.removeItem("UserMessage"); // Clear after showing
    }
};
  return (
   <div>
  <ToastContainer />
    <Loader loading={Loading} />
      <div className="border border-1">
        <div className="d-flex bg-info text-white p-2 align-items-center justify-content-between-center">
        
          <div className="col-md-6">
            <h5 className="no-margin" style={{marginBottom: "0px"}}>User Details</h5>
          </div>
         
          {/* <div className="col-md-6 text-end">
            {(user.role===1 || user.role===2)&&(
   <button className="btn btn-primary">Create Bug</button>
            )}
          </div> */}
        </div>
        <ToastContainer />
<form onSubmit={userupdate}>
          <Table striped bordered hover responsive className="shadow-sm mt-3">
            <thead className="table-primary">
              <tr>
                <th>User ID</th>
                <th>User Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Phone</th>
                <th>Created Date</th>
                <th>Project Permission</th>
                <th>Task Permission</th>
                <th>Bug Permission</th>
                <th>StakeHolder Permission</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.map((data) => (
                <React.Fragment key={data.userId}>
                  <tr >
                    <td>UR-{data.userId}</td>
                    <td>
                    <input type="text" name="userName" id="userName" className="form-control"
                    onChange={(e)=>(setUpdate({
                      ...updateuser,
                      userName:e.target.value
                    }))}
                    defaultValue={data.userName}/>
                    </td>
                    <td><input type="email" name="email" id="email" className="form-control"  onChange={(e)=>(setUpdate({
                      ...updateuser,
                      email:e.target.value
                    }))} defaultValue={data.email}/></td>
                    <td>
                      <select name="role" id="role" className="form-control"  onChange={(e)=>(setUpdate({
                      ...updateuser,
                      role:e.target.value
                    }))} defaultValue={data.role}>
                        <option value="">{data.role}</option>
                        {role.map((roledata)=>(
                          <option key={roledata.id} value={roledata.id}>{roledata.name}</option>
                        ))}
                      </select>
                    </td>
                    <td>
                     <input type="number" name="contact_No" id="" className="form-control" onChange={(e)=>(setUpdate({
                      ...updateuser,
                      contact_No:e.target.value
                     }))} defaultValue= {data.contact_No} placeholder={data.contact_No} required/>
                    
                    </td>
    <td>{new Date(data.createdDate).toISOString().split("T")[1]}</td>
    
    {/* Project Permissions */}
    <td>
<input
 type="checkbox"
 checked={(userPermissionn.permission).split(',').includes('7')}
 onChange={(e) => handleCheckboxChange(7, e.target.checked)}
 className="form-check-input ms-2"
/>
<label className="form-label ms-2">Create</label>

<input
 type="checkbox"
 checked={(userPermissionn.permission).split(',').includes('8')}
 onChange={(e) => handleCheckboxChange(8, e.target.checked)}
 className="form-check-input ms-2"
/>
<label className="form-label"> Edit</label>

<input
 type="checkbox"
 checked={(userPermissionn.permission).split(',').includes('9')}
 onChange={(e) => handleCheckboxChange(9, e.target.checked)}
 className="form-check-input ms-2"
/>
<label className="form-label"> View</label>
</td>
  {/* task Permissions */}
<td>
<input
 type="checkbox"
 checked={(userPermissionn.permission).split(',').includes('4')}
 onChange={(e) => handleCheckboxChange(4, e.target.checked)}
 className="form-check-input ms-2"
/>
<label className="form-label ms-2">Create</label>

<input
 type="checkbox"
 checked={(userPermissionn.permission).split(',').includes('5')}
 onChange={(e) => handleCheckboxChange(5, e.target.checked)}
 className="form-check-input ms-2"
/>
<label className="form-label"> Edit</label>

<input
 type="checkbox"
 checked={(userPermissionn.permission).split(',').includes('6')}
 onChange={(e) => handleCheckboxChange(6, e.target.checked)}
 className="form-check-input ms-2"
/>
<label className="form-label"> View</label>
</td>
<td>
    <input
      type="checkbox"
      checked={(userPermissionn.permission).split(',').includes('1')}
      onChange={(e) => handleCheckboxChange(1, e.target.checked)}
      className="form-check-input ms-2"
    />
    <label className="form-label ms-2">Create</label>

    {/* Edit Checkbox */}
    <input
      type="checkbox"
      checked={(userPermissionn.permission).split(',').includes('2')}
      onChange={(e) => handleCheckboxChange(2, e.target.checked)}
      className="form-check-input ms-2"
    />
    <label className="form-label"> Edit</label>

    {/* View Checkbox */}
    <input
      type="checkbox"
      checked={(userPermissionn.permission).split(',').includes('3')}
      onChange={(e) => handleCheckboxChange(3, e.target.checked)}
      className="form-check-input ms-2"
    />
    <label className="form-label"> View</label>
  </td>





{/* Bug Permissions */}

<td>
<input
 type="checkbox"
 checked={(userPermissionn.permission).split(',').includes('10')}
 onChange={(e) => handleCheckboxChange(10, e.target.checked)}
 
 className="form-check-input ms-2"
/>
<label className="form-label"> Edit</label>

<input
 type="checkbox"
 checked={(userPermissionn.permission).split(',').includes('11')}
 onChange={(e) => handleCheckboxChange(11, e.target.checked)}
 className="form-check-input ms-2"
/>
<label className="form-label"> View</label>
</td>
    <td className="d-flex">
      <button className="btn btn-warning" type="submit">Update</button>
   
      <button className="btn btn-danger ms-3" type="button" onClick={() => {
                      setSelectedUser(data.userId);
                      
                      setDisableMode(true);
                    }}
>Disable</button>
    </td>
 
                  </tr>
               
             
       
        
                </React.Fragment>
              ))}
              <tr>
                
              </tr>
            </tbody>
          </Table>
          </form>
      </div>
      <div className="mt-3 d-flex">
        <div className="col-md-4 p-1 border-1">
        <div
            className="d-flex bg-info p-2 text-white align-items-center"
            p-1
            
          >
            <h5 style={{marginBottom: "0px"}}>Projects</h5>
          </div>
          {projects.length>0 ?(
          <div p-1 className="p-1 tbdata">
            <Table
              striped
              bordered
              hover
              responsive
              className=" shadow-sm mt-3"
            >
              <thead className="table-primary ">
                <tr>
                  <th>Project ID</th>
                  <th>Project Name</th>
                </tr>
              </thead>
              <tbody>
                {projects.map((data)=>(                    
                   <tr 
                   key={data.projectId}
                   
                   onClick={() => handleprojectpage(data.projectId)}
                 >
                   <td>PR-{data.projectId}</td>
                   <td>{data.projectName}</td>
                 </tr>
                ))}
              </tbody>
            </Table>
          </div>
          ):(
            <div className="p-1 text-center">
              <p>No Projects Assigned</p>
            </div>
          )
        }
        </div>

{/*  */}

<div className="col-md-4 p-1 border-1">
        <div
            className="d-flex bg-info p-2 text-white align-items-center"
           
          >
            <h5 style={{marginBottom: "0px"}}>Tasks</h5>
          </div>
          <div  className="p-1 tbdata">
            {tasks.length>0 ?(
 <Table
 striped
 bordered
 hover
 responsive
 className=" shadow-sm mt-3"
>
 <thead className="table-primary ">
   <tr>
     <th>TaskId</th>
     <th>Task Name</th>
     <th>Status</th>
   </tr>
 </thead>
 <tbody>
   {tasks.map((task)=>(
       <tr key={task.projectTaskId} onClick={() => handletaskpage(task.projectTaskId)}>
           <td>TS-{task.projectTaskId}</td>
           <td>{task.taskName}</td>
           <td style={{
            backgroundColor:getStatusColor(task.status),
             color: "white",
             textAlign: "center"
           }} 
           >{task.status }</td>
       </tr>
   ))}
 </tbody>
</Table>
            ):
            (
<p className="text-center">No Tasks Assigned</p>
            )}
           
          </div>
        </div>

{/*  */}

<div className="col-md-4 p-1 border-1">
        <div
            className="d-flex bg-info p-2 text-white align-items-center"
            
          >
            <h5 style={{marginBottom: "0px"}}>Bugs</h5>
          </div>

          {bugs.length>0 ? (
          <div  className=" p-1 tbdata">
            <Table
              striped
              bordered
              hover
              responsive
              className=" shadow-sm mt-3"
            >
              <thead className="table-primary ">
                <tr>
                <th>BugId</th>
                  <th>Bug Name</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {bugs.map((bug)=>(
                    <tr key={bug.bugId} onClick={() => handlebugpage(bug.bugId)}>
                        <td>BG-{bug.bugId}</td>
                        <td>{bug.bugName}</td>
                        <td style={{
            backgroundColor:getStatusColor(bug.status),
             color: "white",
             textAlign: "center"
           }} >{bug.status }</td>
                    </tr>
                ))}
              </tbody>
            </Table>
          </div>
          ):(
            <p className="text-center">No Bugs Assigned</p>
          )}
        </div>

      </div>

      {disableMode && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          {(tasks.length === 0 && bugs.length === 0 && projects.length === 0)?(
<div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Disable</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setDisableMode(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to disable this user?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setDisableMode(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={disableuser}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
          ):(
            <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Confirm Disable</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setDisableMode(false)}
        ></button>
      </div>
      <div className="modal-body">
        <div className="d-flex justify-content-between align-items-center">
          <p>Re-Assign the assigned works</p>
          <button
            type="button"
            className="btn btn-warning ms-3"
            onClick={() =>
              setReassign({
                ...Reassign,
                assignedToPerson: "unassigned",
              })
            }
          >
            Unassign All
          </button>
        </div>
        <form>
          <div className="container py-3">
            {/* Projects Section */}
            <div className="overflow-auto mb-4" style={{ maxHeight: "150px" }}>
              <h6 className="mb-3">{projects.length} Projects Assigned</h6>
              {projects.map((project) => (
                <div className="d-flex align-items-center mb-3" key={project.id}>
                  {/* Project Name */}
                  <div
                    className="p-2 flex-grow-1 border rounded bg-light"
                    onClick={() =>
                      setReassign({
                        ...Reassign,
                        projectId: project.id,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <strong>{project.projectName}</strong>
                  </div>

                  {/* Multiselect */}
                  <div className="ms-3" style={{ flex: "0 0 40%" }}>
                    <select
                      name="assignedTo"
                      id="assignedTo"
                      value={Reassign.assignedToPerson}
                      onChange={(e) =>
                        setReassign({
                          ...Reassign,
                          assignedToPerson: e.target.value,
                        })
                      }
                    >
                      <option value="">Assign To users</option>
                      {users.map((userdata) => (
                        <option key={userdata.id} value={userdata.id}>
                          {userdata.name}
                        </option>
                      ))}
                      <option value="unassigned">Unassigned</option>
                    </select>
                  </div>
                </div>
              ))}
            </div>

            {/* Tasks Section */}
            <div className="overflow-auto mb-4" style={{ maxHeight: "150px" }}>
              <h6 className="mb-3">{tasks.length} Tasks Assigned</h6>
              {tasks.map((task) => (
                <div className="d-flex align-items-center mb-3" key={task.id}>
                  {/* Task Name */}
                  <div
                    className="p-2 flex-grow-1 border rounded bg-light"
                    onClick={() =>
                      setReassign({
                        ...Reassign,
                        projectTaskId: task.projectTaskId,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <strong>{task.taskName}</strong>
                  </div>

                  {/* Multiselect */}
                  <div className="ms-3" style={{ flex: "0 0 40%" }}>
                    <select
                      name="assignedTo"
                      id="assignedTo"
                      value={Reassign.assignedToPerson}
                      onChange={(e) =>
                        setReassign({
                          ...Reassign,
                          assignedToPerson: e.target.value,
                        })
                      }
                    >
                      <option value="">Assign To users</option>
                      {users.map((userdata) => (
                        <option key={userdata.id} value={userdata.id}>
                          {userdata.name}
                        </option>
                      ))}
                      <option value="unassigned">Unassigned</option>
                    </select>
                  </div>
                </div>
              ))}
            </div>

            {/* Bugs Section */}
            <div className="overflow-auto" style={{ maxHeight: "150px" }}>
              <h6 className="mb-3">{bugs.length} Bugs Assigned</h6>
              {bugs.map((bug) => (
                <div className="d-flex align-items-center mb-3" key={bug.id}>
                  {/* Bug Name */}
                  <div
                    className="p-2 flex-grow-1 border rounded bg-light"
                    onClick={() =>
                      setReassign({
                        ...Reassign,
                        bugId: bug.id,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <strong>{bug.bugName}</strong>
                  </div>

                  {/* Multiselect */}
                  <div className="ms-3" style={{ flex: "0 0 40%" }}>
                    <select
                      name="assignedTo"
                      id="assignedTo"
                      value={Reassign.assignedToPerson}
                      onChange={(e) =>
                        setReassign({
                          ...Reassign,
                          assignedToPerson: e.target.value,
                        })
                      }
                    >
                      <option value="">Assign To users</option>
                      {users.map((userdata) => (
                        <option key={userdata.id} value={userdata.id}>
                          {userdata.name}
                        </option>
                      ))}
                      <option value="unassigned">Unassigned</option>
                    </select>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </form>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => setDisableMode(false)}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={disableuser}
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
          
          )
        }
          
        </div>
      )}


    </div>
  );
};

export default UserDetails;
